module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/join-our-agents/hero-desktop.d08dc3d655bb5f2360e83f6352bd11cf.jpg";